import React from 'react';
import { cn } from '../../utils/cn';

export const CarouselItem = ({
    className,
    ...props
}: React.HTMLAttributes<HTMLDivElement>) => {
    return (
        <div
            role="group"
            aria-roledescription="slide"
            className={cn(
                'h-full min-w-0 shrink-0 grow-0 basis-full',
                className
            )}
            {...props}
        />
    );
};
